/* lua.js generated code 0.3.0 */

var LoginBuffer = xClass("LoginBuffer")
var instance = null
LoginBuffer.getInstance = function () {
    var self = this
    if (!instance) {
        instance = LoginBuffer.create()
    }
    return instance
}
LoginBuffer.prototype.dispose = function () {
    var self = this
    instance = null
}
LoginBuffer.prototype.ctor = function () {
    var self = this
    self.originUid = 0
    self.oauthType = PlatformAuthEnum.kGuest
    self.openIdTable = null
    self.snsUserInfo = table(
        [1, "openid", ""],
        [1, "nickname", "游客"],
        [1, "sex", 2],
        [1, "image", ""],
        [1, "unionid", ""]
    )
    self.isNewUser = false
}
LoginBuffer.prototype.readUserLoginInfo = function (uid) {
    var self = this
    self.originUid = uid
    self.oauthType = Localhost.getLastLoginOauthID()
    self.originOauthType = self.oauthType
    self.openIdTable = Localhost.getCurrentUserOpenId()
    self.snsUserInfo = Localhost.getSnsUserInfo()
}
LoginBuffer.prototype.getOriginUid = function () {
    var self = this
    return self.originUid
}
LoginBuffer.prototype.getOAuthType = function () {
    var self = this
    return self.oauthType
}
LoginBuffer.prototype.setOAuthType = function (oauthType) {
    var self = this
    self.oauthType = oauthType
}
LoginBuffer.prototype.getOpenId = function () {
    var self = this
    // WARN: maybe multi result
    return clone(self.openIdTable)
}
LoginBuffer.prototype.setOpenId = function (oauthType, openId, accessToken, expireTime, refreshToken, expireRefresh) {
    var self = this
    self.openIdTable = table(
        [1, "oauthType", oauthType],
        [1, "openId", openId],
        [1, "accessToken", accessToken],
        [1, "expireTime", expireTime],
        [1, "refreshToken", refreshToken],
        [1, "expireRefresh", expireRefresh]
    )
}
LoginBuffer.prototype.setOpenIdConnected = function () {
    var self = this
    if (type(self.openIdTable) === "table") {
        self.openIdTable.connected = true
    }
}
LoginBuffer.prototype.getSnsUserInfo = function () {
    var self = this
    // WARN: maybe multi result
    return clone(self.snsUserInfo)
}
LoginBuffer.prototype.setSnsUserInfo = function (openid, nickname, sex, image, unionid) {
    var self = this
    self.snsUserInfo = table(
        [1, "openid", openid],
        [1, "nickname", nickname],
        [1, "sex", sex],
        [1, "image", image],
        [1, "unionid", unionid]
    )
}
LoginBuffer.prototype.flushLoginOptions = function () {
    var self = this
    Localhost.setLastLoginOauthID(self.oauthType)
    if (self.openIdTable) {
        Localhost.setCurrentUserOpenId(self.openIdTable.oauthType, self.openIdTable.openId, self.openIdTable.accessToken, self.openIdTable.expireTime, self.openIdTable.refreshToken, self.openIdTable.expireRefresh)
    }
    if (self.openIdTable && self.openIdTable.connected) {
        Localhost.setCurrentUserOpenIdConnected()
    }
    Localhost.setSnsUserInfo(self.snsUserInfo.openid, self.snsUserInfo.nickname, self.snsUserInfo.sex, self.snsUserInfo.image, self.snsUserInfo.unionid)
}
LoginBuffer.prototype.setIsNewUser = function (value) {
    var self = this
    self.isNewUser = value
}
LoginBuffer.prototype.getIsNewUser = function () {
    var self = this
    return self.isNewUser
}
module.exports = LoginBuffer
